// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2JUDq","title":"AfterFrontImage_title__82qyp"};